import React from "react";
import ReactCrop from "react-image-crop";
import "../../../styles/onboardingStep1.css";
import "../onboarding/onboarding3.css";
import Modal from "react-bulma-components/lib/components/modal";
import "react-image-crop/dist/ReactCrop.css";
import Button from "react-bulma-components/lib/components/button";
import "../../../styles/uploadimage.css";
import "../../../styles/myProfile.css";
import { Redirect, withRouter } from "react-router-dom";

import { base64StringtoFile, extractImageFileExtensionFromBase64, image64toCanvasRef } from "../../../helpers/reusable";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateIfInputIsEmail,
    validateInputLength,
    validateIfInputHasEmail,
    validateIfInputHasCharactersAllowSpaces
} from "../../../helpers/validationChecks";
import { CountryDropdown } from "react-country-region-selector";
import { inject, observer } from "mobx-react";
import resizer from "image-resizer-js";


import "bootstrap/dist/css/bootstrap.min.css";
import { createBrowserHistory as createHistory } from 'history'

const history = createHistory()
const getInitialState = () => ({

    imageCropped: false,
    showCropMode: false,
    cropDetails: {},
    modifiedImages: [],
    modifiedImagesThumbnail: [],
    selectedOriginalImageUrl: '',
    selectedOriginalImage: null,
    selectedFile: null,
    wantsToGoBack: false,
    wantsToSeeFeed: false,
    showInformationForName: false,
    displayNameValid: "NA",
    formInputs: {
        image: false,
        full_name: "",
        display_name: "",
        country: "",
        primary_email: "",
        preferred_currency: "",
        old_display_name: ""
    }
});
const MAX_IMAGES = 1;

@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'generalStore')
@withRouter
@observer
export default class onboardingStep3 extends React.Component {

    constructor(props) {
        super(props);
        this.imagePreviewCanvasRef = React.createRef()
        this.state = getInitialState();
    }



    getData(navigator) {
        if (window.localStorage.hasOwnProperty("userData")) {
            // console.log("monnt")
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);

                    if (!response.data[0].interests) {
                        this.setState({
                            makeOB1Incomplete: true
                        })

                    }
                    if (!response.data[0].preferences) {
                        this.setState({
                            makeOB2Incomplete: true
                        })

                    }

                    this.setState({
                        curr_display_name: (response.data[0].display_name) ? response.data[0].display_name : response.data[0].old_display_name,
                        formInputs: {
                            ...this.state.formInputs,
                            image: (!!response.data[0].image) ? response.data[0].image : (localStorage.hasOwnProperty("fb_id")) ? `http://graph.facebook.com/${localStorage.getItem("fb_id")}/picture?type=large` : "",
                            full_name: response.data[0].full_name,
                            display_name: (response.data[0].display_name) ? response.data[0].display_name : response.data[0].old_display_name,
                            country: response.data[0].country,
                            // primary_email: ((!!response.data[0].primary_email &&
                            //     response.data[0].primary_email.includes("somerandomemail")) ||
                            //     !response.data[0].primary_email) ?
                            //     localStorage.hasOwnProperty("fb_email") ?
                            //         localStorage.getItem("fb_email") :
                            //         localStorage.hasOwnProperty("goog_email") ?
                            //             localStorage.getItem("goog_email") :
                            //             response.data[0].primary_email || localStorage.getItem("login_email") :
                            //     response.data[0].primary_email || localStorage.getItem("login_email"),
                            primary_email: ((!response.data[0].primary_email) ||
                            response.data[0].primary_email.includes("somerandomemail") ?
                                localStorage.hasOwnProperty("fb_email") ?
                                    localStorage.getItem("fb_email") :
                                    localStorage.hasOwnProperty("goog_email") ?
                                        localStorage.getItem("goog_email") :
                                       
                                localStorage.getItem("login_email") :
                                response.data[0].primary_email ),
                            preferred_currency: response.data[0].preferred_currency,
                            email_verified: response.data[0].email_verified,
                        }
                    }, () => this.handleDisplayNameBlurr(true, navigator))
                })
        }
    }
    componentDidMount() {
        this.getData(true)
        // console.log("[monnt identifier ob3]")
        // this.backListener = history.listen(location => {
        //     if (location.hash === "#/") {
        //         this.setState({toOB3 : true})
        //     }
        // });

    }
    handleBackClick() {
        // console.log("coming here")
        // if (!this.props.authStore.RegisterSuccess) {
        localStorage.clear();
        window.location.reload()
        // }
        // else this.props.navigatorStore.openOB2Modal();
    }
    componentWillReceiveProps(nextProps) {
        // if (this.props.authStore.loginDone || this.props.RegisterSuccess) {
        this.getData();
        //   }
    }
    onCloseCrop() {
        this.setState({ showCropMode: false });
    }
    handleInputChange(event) {
        this.setState({ formInputs: { ...this.state.formInputs, [event.target.name]: event.target.value } }, () => {
            // console.log("changed the input box ", this.state.formInputs);
        })
    }
    selectCountry(item) {
        this.setState({ formInputs: { ...this.state.formInputs, country: item } }
            , () => { // console.log(this.state.formInputs.country) 
            })
    }
    showImage(event) {
        // console.log("[showImage] ", event.target.name);
        // let reader = new FileReader();
        var currentFile = event.target.files[0];
        var originalImageUrl = URL.createObjectURL(currentFile);
        this.setState({
            showCropMode: true,
            selectedOriginalImage: currentFile,
            selectedOriginalImageUrl: originalImageUrl,
        })
    }
    handleOnCropChange = (cropDetails) => {
        this.setState({ cropDetails })
    }
    handleOnCropComplete = (crop, pixelCrop) => {
        // console.log("[crop complete]", pixelCrop);

        const canvasRef = this.imagePreviewCanvasRef.current
        image64toCanvasRef(canvasRef, this.state.selectedOriginalImageUrl, pixelCrop);
        // croppedImage
        // const imageData64 = canvasRef.toDataURL('image/' + extractImageFileExtensionFromBase64(this.state.selectedOriginalImage))
        // const croppedImage = base64StringtoFile(imageData64, 'unnamed_file');
        // const croppedImageUrl = URL.createObjectURL(croppedImage)
        this.setState({
            //pixelCropState: pixelCrop,
            imageCropped: true,
            // selectedCroppedImage: croppedImage,
            // selectedCroppedImageUrl: croppedImageUrl,
        })
    }
    handleImageLoaded = (image) => {
        // // console.log("asdfghj", image);
        // // console.log("asdfghjasd", image.src);
        this.setState({
            // selectedOriginalImage: image
        })
    }
    onImageCropDone() {
        this.setState({
            preview: ""
        })
        const scope = this;
        scope.onCloseCrop();
        const canvasRef = this.imagePreviewCanvasRef.current
        // console.log("this.state.selectedOriginalImageUrlthis.state.selectedOriginalImageUrl", this.state.selectedOriginalImageUrl)
        const imageData64 = canvasRef.toDataURL('image/' + extractImageFileExtensionFromBase64(this.state.selectedOriginalImageUrl))
        // const myFilename = this.state.file
        const myNewCroppedFile = base64StringtoFile(imageData64, "unnamed_file_2.png");
        // // console.log("myNewCroppedFilenm", this.state.imageCropped, myNewCroppedFile);
        const imageUrl = URL.createObjectURL(myNewCroppedFile)
        // // console.log("FileUrl", myNewCroppedFile.name)
        // // console.log(this.state.crop)
        if (this.state.imageCropped) {
            // Initiate the JavaScript Image object.
            var image = new Image();
            // Set the Base64 string return from FileReader as source.
            image.src = imageUrl;
            image.onload = () => {
                var height = image.height;
                var width = image.width;
                // // console.log("cropped dimensions", height, width)
                scope.setState({
                    selectedCroppedImage: myNewCroppedFile,
                    selectedCroppedImageUrl: imageUrl,
                    cropDetails: {},
                    imageCropped: false
                }, () => {
                    // console.log(scope.state)
                    scope.validateImageDimensions(height, width);
                })
            }
        }
        else {
            var image = new Image();
            image.src = scope.state.selectedOriginalImageUrl;
            image.onload = () => {
                var height = image.height;
                var width = image.width;
                scope.setState({
                    selectedCroppedImage: scope.state.selectedOriginalImage,
                    selectedCroppedImageUrl: scope.state.selectedOriginalImageUrl,
                }, () => {
                    // console.log(scope.state)
                    scope.validateImageDimensions(height, width);
                });
            }
        }
    }

    validateImageDimensions(height, width) {
        // console.log("selectedCroppedImage", this.state.selectedCroppedImage)
        // console.log("[validateImageDimensions] image dimensions", height, width)
        if ((height >= width && height < 512) || (width >= height && width < 512)) {
            this.props.navigatorStore.openErrorModal("Please upload picture of size greater than 512x512");
            this.onImageReject();
            return;
        }
        let newHeight = height;
        let newWidth = width;
        if (width >= height && width > 1080) {
            newWidth = 1080
            newHeight = (height / width) * newWidth;
        }
        else if (height >= width && height > 1080) {
            newHeight = 1080
            newWidth = (width / height) * newHeight;
        }
        this.onImageAccept(newHeight, newWidth);
    }

    onImageAccept(newHeight, newWidth) {
        // console.log("[onImageAccept]", newHeight, newWidth)
        this.setState({  modifiedImages:
            // this.state.modifiedImages.concat(
            {
                url: this.state.selectedCroppedImageUrl,
                img: this.state.selectedCroppedImage,
                height: newHeight,
                width: newWidth,
            }
            // )    
            ,

            selectedCroppedImageUrl: null,
            selectedCroppedImage: null,
            selectedOriginalImage: null,
            selectedOriginalImageUrl: null,
            crop: null
            // finalImageHeight: newHeight,
            // finalImageWidth: newWidth
        }, () => {
            // console.log("did set the new height and width", this.state)
        })
        this.setState({  modifiedImagesThumbnail:
            // this.state.modifiedImages.concat(
            {
                url: this.state.selectedCroppedImageUrl,
                img: this.state.selectedCroppedImage,
                height: 500,
                width: 500,
            }})
    }

    onImageReject() {
        let { selectedCroppedImageUrl, selectedCroppedImage } = getInitialState();
        this.setState({
            selectedCroppedImageUrl, selectedCroppedImage, imageCropped: false,
            cropDetails: {},
        }
        )
    }


    handleSaveClick() {
        if (!this.state.formInputs.display_name) {
            this.props.navigatorStore.openErrorModal("Please enter your username");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }

        if (!this.state.formInputs.full_name) {
            this.props.navigatorStore.openErrorModal("Name must be between 2 to 150 characters");
            return;
        }
        if (!this.state.formInputs.country || this.state.formInputs.country.length == 0) {
            this.props.navigatorStore.openErrorModal("Please select the country");
            return;
        }
        if (!this.state.formInputs.preferred_currency || this.state.formInputs.preferred_currency.length == 0) {
            this.props.navigatorStore.openErrorModal("Please select your preferred currency");
            return;
        }
        if (!this.state.formInputs.primary_email) {
            this.props.navigatorStore.openErrorModal("Please enter the email where you would like to receive important messages from us.");
            return;
        }


        // if (!validateInputLength(this.state.formInputs.bio, 0, 750)) {
        //       this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
        //     return;
        // }

        if ((this.state.formInputs.full_name) && !validateInputLength(this.state.formInputs.full_name, 2, 150)) {
            this.props.navigatorStore.openErrorModal("Name must be between 2 to 150 characters");
            return;
        }
        if ((this.state.formInputs.full_name) && !validateIfInputHasCharactersAllowSpaces(this.state.formInputs.full_name)) {
            this.props.navigatorStore.openErrorModal("Name cannot contain spaces, special characters or uppercase letters");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if (this.state.formInputs.country == 0) {
            this.props.navigatorStore.openErrorModal("Please select your country");
            return;
        }
        if ((!this.state.formInputs.primary_email) || !validateIfInputIsEmail(this.state.formInputs.primary_email)) {
            this.props.navigatorStore.openErrorModal("This communication email is not valid");
            return;
        }
        // if (validateIfInputHasTenDigits(this.state.formInputs.bio)) {
        //       this.props.navigatorStore.openErrorModal("bio can not contain a phone number");
        //     return;
        // }
        // if (!validateIfInputHasUrl(this.state.formInputs.bio)) {
        //       this.props.navigatorStore.openErrorModal("bio can not contain a url");
        //     return;
        // }

        if ((this.state.formInputs.display_name) && !validateInputLength(this.state.formInputs.display_name, 6, 30)) {
            this.props.navigatorStore.openErrorModal("Username must be between 6 and 30 characters long");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && !validateIfInputHasSpaces(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasCharacters(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters");
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasUpperCaseLetter(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username cannot contain spaces, special characters or uppercase letters")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasYourMasterpieces(this.state.formInputs.display_name)) {
            this.props.navigatorStore.openErrorModal("Username must not contain 'yourmasterpieces'")
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        var formData = new FormData();
        formData.append("display_name", this.state.formInputs.display_name)
        // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
        //     this.props.userStore.validateDisplayName(formData)
        //         .then((response) => {
        //             // console.log(response)
        //             if (response.error == "True") {
        //                 this.setState({
        //                     displayNameValid: "invalid",
        //                     formInputs: { ...this.state.formInputs, display_name: "" }
        //                 })
        //                 this.props.navigatorStore.openErrorModal(response.data)
        //                 return;
        //             }
        //             else {
        //                 this.setState({
        //                     displayNameValid: "valid",
        //                 }, window.localStorage.setItem('display_name', this.state.formInputs.display_name),
        //                     this.props.userStore.pulluser())
        //             }
        //         })
        //         .catch((err => {
        //             this.setState({
        //                 displayNameValid: "invalid",

        //                 formInputs: { ...this.state.formInputs, display_name: "" }

        //             }, this.props.navigatorStore.openErrorModal("Sorry, this username is not available "))
        //         }));

        // this.handleDisplayNameBlurr();
        this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
        this.props.authStore.resetOnboardingStatuses("onboardingTwoIncomplete");
        this.props.authStore.resetOnboardingStatuses("onboardingoneIncomplete");
        this.props.authStore.resetRegisterSuccess();
        window.localStorage.setItem('preferred_currency', this.state.formInputs.preferred_currency);
        let _scope = this;
        if (!_scope.state.modifiedImages.url) {
            // console.log(this.state)
            var formData = new FormData();
            // formData.append("image", blob, "myFile.png");
            formData.append("country", _scope.state.formInputs.country);
            formData.append("full_name", _scope.state.formInputs.full_name);
            (_scope.state.curr_display_name == _scope.state.formInputs.display_name) ? "" : formData.append("display_name", _scope.state.formInputs.display_name);
            formData.append("primary_email", _scope.state.formInputs.primary_email);
            formData.append("preferred_currency", _scope.state.formInputs.preferred_currency);
            _scope.props.userStore.requestToEditUser(formData)
                .then((response) => {
                    if (response.error == "True") {
                        this.setState({
                            displayNameValid: "invalid",
                            formInputs: { ...this.state.formInputs, display_name: "" },
                            // onboardingComplete: true
                        })

                        this.props.navigatorStore.openErrorModal(response.data)

                    }
                    else {
                        this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
                        this.props.authStore.resetOnboardingStatuses("onboardingOneIncomplete");
                        this.props.authStore.resetOnboardingStatuses("onboardingTwoIncomplete");
                        this.props.authStore.resetRegisterSuccess();
                        this.props.navigatorStore.closeOB3Modal();
                        // console.log(response)
                        this.setState({

                        })
                    }
                })


        }

        else {
            // let imageProcessPromises = _scope.state.modifiedImages.map(fileDetailObj => 
            _scope.resizeAndUploadOneImage(_scope.state.modifiedImages,"image");
            _scope.resizeAndUploadOneImage(_scope.state.modifiedImagesThumbnail, "timg");
        }
        // Promise.all(imageProcessPromises).then(resolutions => {
        //     // console.log("resolutions = ", resolutions);
        //       this.props.navigatorStore.openErrorModal("SUCCESS!!");
        //     _scope.setState({
        //         submittedImages: true
        //     })
        // }).catch(issueInUploading => {
        //     // console.log(issueInUploading);
        //       this.props.navigatorStore.openErrorModal("Error Uploading Image ")
        // })

    }

    resizeAndUploadOneImage(fileDetailObj, key) {
        let _scope = this;
        return new Promise((resolve, reject) => {
            const options = {
                maxWidth: fileDetailObj.width,
                maxHeight: fileDetailObj.height,
            }
            const fileReader = new FileReader();
            // // console.log("with width and height", _scope.state.finalImageWidth, _scope.state.finalImageHeight);
            let arrayBuffer;
            fileReader.onload = function (event) {
                // // console.log("with width and height", options);
                arrayBuffer = event.target.result;
                resizer(arrayBuffer, options)
                    .then(image => {
                        // // console.log("img ", image)
                        // // console.log("with width and height", _scope.state.finalImageWidth, _scope.state.finalImageHeight);
                        // image resized
                        const blob = new Blob([image], { type: 'image/png' });
                        // const blob = new Blob([image]);
                        image.src = blob;
                        var formData = new FormData();
                        _scope.setState({
                            finalImage: blob
                        })
                        formData.append(key, blob, "myFile.png");
                        formData.append("country", _scope.state.formInputs.country);
                        formData.append("full_name", _scope.state.formInputs.full_name);
                        (_scope.state.curr_display_name == _scope.state.formInputs.display_name) ? "" : formData.append("display_name", _scope.state.formInputs.display_name);
                        formData.append("primary_email", _scope.state.formInputs.primary_email);
                        formData.append("preferred_currency", _scope.state.formInputs.preferred_currency);
                        formData.append("image_uploaded", true);
                        // console.log(formData)
                        _scope.props.userStore.requestToEditUser(formData, null, true)
                            .then((response) => {
                                // console.log("[changed the propic]", response)
                                _scope.setState({
                                    wantsToSeeFeed: true,
                                    formInputs: {
                                        ..._scope.state.formInputs,
                                        image: response.data.image
                                    }

                                }, function () {
                                    this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
                                    window.localStorage.setItem('image', _scope.state.formInputs.image)
                                    _scope.props.userStore.pulluser()
                                    this.props.history.replace('/')
                                }
                                )
                            })
                    })
            };
            fileReader.readAsArrayBuffer(fileDetailObj.img);
        })
    }

    handlePrevClick() {
        this.setState({
            wantsToGoBack: true
        })
    }
    handleShowMyFeedClick() {
        this.setState({
            wantsToSeeFeed: true
        })
    }
    showImage(event) {
        // console.log("[showImage] ", event.target.name);
        // let reader = new FileReader();
        var currentFile = event.target.files[0];
        var originalImageUrl = URL.createObjectURL(currentFile);
        this.setState({
            showCropMode: true,
            selectedOriginalImage: currentFile,
            selectedOriginalImageUrl: originalImageUrl,
        })
    }
    showInformationForName(item) {
        switch (item) {
            case ("name"): {
                this.setState({
                    showInformationForName: !this.state.showInformationForName
                })
                break;
            }
            case ("display_name"): {
                this.setState({
                    showInformationFordisplayName: !this.state.showInformationFordisplayName
                })
                break;
            }
            case ("email"): {
                this.setState({
                    showInformationForEmail: !this.state.showInformationForEmail
                })
                break;
            }
        }
    }

    handleDisplayNameBlurr(popup, navigator) {


        if ((this.state.formInputs.display_name) && !validateInputLength(this.state.formInputs.display_name, 6, 30)) {
            !popup && this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
            // console.log("stuff", !navigator)
            if (!navigator) {
                // console.log("stuff", !navigator)
                this.setState({ toOB3: true })
                return;
            }
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && !validateIfInputHasSpaces(this.state.formInputs.display_name, 6, 30)) {
            !popup && this.props.navigatorStore.openErrorModal("username can not contain spaces")
            if (navigator) {
                this.setState({ toOB3: true })
                return;
            }
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasCharacters(this.state.formInputs.display_name)) {
            !popup && this.props.navigatorStore.openErrorModal("username can not contain characters");
            if (navigator) {
                this.setState({ toOB3: true })
                return;
            }
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasUpperCaseLetter(this.state.formInputs.display_name)) {
            !popup && this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
            if (navigator) {
                this.setState({ toOB3: true })
                return;
            }
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        if ((this.state.formInputs.display_name) && validateIfInputHasYourMasterpieces(this.state.formInputs.display_name)) {
            !popup && this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
            if (navigator) {
                this.setState({ toOB3: true })
                return;
            }
            this.setState({
                displayNameValid: "invalid"
            })
            return;
        }
        var formData = new FormData();
        formData.append("display_name", this.state.formInputs.display_name)
        if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
            this.props.userStore.validateDisplayName(formData)
                .then((response) => {
                    // console.log(response)
                    if (response.error == "True") {
                        if (navigator) {
                            this.setState({ toOB3: true })
                            return;
                        }
                        this.setState({
                            displayNameValid: "invalid",
                            formInputs: { ...this.state.formInputs, display_name: "" }
                        })
                        !popup && this.props.navigatorStore.openErrorModal(response.data)
                        return;
                    }
                    else {
                        this.setState({
                            displayNameValid: "valid",
                        }, window.localStorage.setItem('display_name', this.state.formInputs.display_name),
                            window.localStorage.setItem('username', this.state.formInputs.display_name),
                            this.props.userStore.pulluser())
                    }
                })
                .catch((err => {
                    this.setState({

                        displayNameValid: "invalid",

                        formInputs: { ...this.state.formInputs, display_name: "" }

                    }, () => !popup && this.props.navigatorStore.openErrorModal("Sorry, this username is not available "))
                }));
    }

    tempDisplayName(event) {
        this.setState({
            formInputs: { ...this.state.formInputs, display_name: event.target.value }
        }, () => {
            // console.log(this.state.tempDisplayName)
        })
    }


    handleCurrencySelection(currencyAbbrevation) {
        // console.log(`Selected ${currencyAbbrevation.target.value}`);
        this.setState({
            formInputs: { ...this.state.formInputs, preferred_currency: currencyAbbrevation.target.value }
        }, function () {
            // console.log(this.state.formInputs.preferred_currency)
        })
    }



    render() {

        // console.log("registered", this.props.authStore.RegisterSuccess)
        // if(this.state.toOB3){
        //     // console.log("doing stuff")
        //     return(
        //         <Redirect push to="onboardingtwo" />
        //     )
        // }
        // if (this.props.authStore.onboardingOneIncomplete) {
        //     // console.log("registred, still hugging")
        //     this.props.authStore.resetOnboardingStatuses("onboardingOneIncomplete")
        //     return (
        //         <Redirect push to="onboardingone" />
        //     )
        // }
        // if (this.props.authStore.onboardingTwoIncomplete) {
        //     this.props.authStore.resetOnboardingStatuses("onboardingTwoIncomplete")
        //     return (
        //         <Redirect push to="onboardingtwo" />
        //     )
        // }
        if (this.state.wantsToGoBack || this.state.navToOB2) {
            return (
                <Redirect push to="onboardingtwo" />
            )
        }
        if (this.state.wantsToSeeFeed) {
            if (!this.props.authStore.RegisterSuccess) {
                return (
                    <Redirect push to="" />
                )
            } else {
                this.props.authStore.resetRegisterSuccess();
                localStorage.setItem("registerDone", true)
                return (
                    <Redirect push to="" />
                )
            }
        }

        return (



            <Modal show={this.props.navigatorStore.OB3Open}>
                <Modal.Content >

                    {/* <img onClick={this.onCloseOB3.bind(this)} className="cross-icon-for-modal" src={require('../../../assets/cross_icon_for_close.png')}></img> */}
                    <Modal show={this.state.showCropMode} onClose={this.onCloseCrop.bind(this)} >
                        <Modal.Content>
                            <div className="crop-screen-header">
                                <p className="crop-screen-heading">CROP
                            <img onClick={this.onCloseCrop.bind(this)} className="cross-icon-for-modal" src={require('../../../assets/cross_icon_for_close.png')}></img></p>
                            </div>
                            <div className="crop-screen-image">
                                <ReactCrop
                                    src={this.state.selectedOriginalImageUrl}
                                    crop={this.state.cropDetails}
                                    onImageLoaded={this.handleImageLoaded.bind(this)}
                                    onComplete={this.handleOnCropComplete.bind(this)}
                                    onChange={this.handleOnCropChange.bind(this)}
                                />
                            </div>
                            <canvas style={{ display: "none" }} ref={this.imagePreviewCanvasRef}></canvas>
                            <Button className="masterpieces-primary-buttons" id="crop-screen-button" onClick={this.onImageCropDone.bind(this)}><p style={{ fontFamily: "Montserrat", color: "#FFFFFF" }}>Done</p></Button>
                        </Modal.Content>
                    </Modal>
                    <div className="heading-welcome">
                        ONE LAST THING
                <hr className="line-category-name margin-auto"></hr>
                    </div>

                    <div className="container editProfile onboarding-container" style={{ padding: "0px", width: "91%" }}>
                        <div className="content-onboarding-step">
                            <div className="heading-text">
                                <div className="onboarding-question">
                                    Tell us about you
                            </div>
                                {/* <div className="onboarding-step-number">
                                    Step 3 of 3
                            </div> */}
                            </div>
                            <div className="user-photo-name-username">
                                <div className="user-profile-photo">
                                    <img alt="" className="image-preview-profile-picture" src={this.state.modifiedImages.url || this.state.formInputs.image ||  require('../../../assets/default_picture.png')} ></img>
                                         {/* {this.state.modifiedImages.map((modifiedImage, imageIdx) => ( */}
                                            {/* <img alt="" className="image-preview-profile-picture" src={this.state.modifiedImages.url || "http://yourmasterpieces.com/auth/user/images/edit_profile.png"}  ></img> */}
                                {/* ))} */}
                                    <img src={require('../../../assets/pick_photo_tap_svg.svg')} className="select-photo-tap-icon" />
                                    <input type="file" className="select-user-profile-photo" onChange={this.showImage.bind(this)}
                                        onClick={(event) => {
                                            event.target.value = null
                                        }} accept="image/*"></input>
                                </div>
                                <div className="user-name-and-username">

                                    <div className="basic-info-text">
                                        Your username is your profile handle and your very personal art gallery online
                                </div>

                                    <div className="form-element-user-profile">
                                        <p className="form-section-name-user-profile">USERNAME
                                        <img style={{ display: (this.state.displayNameValid == "invalid") ? "" : "none" }} className="success-status-icon" src={require('../../../assets/cross.png')}  ></img>
                                            <img style={{ display: (this.state.displayNameValid == "valid") ? "" : "none" }} className="success-status-icon" src={require('../../../assets/success-icon.png')}  ></img></p>
                                        <input value={this.state.formInputs.display_name} type="text" name="display_name"
                                            onChange={this.tempDisplayName.bind(this)}
                                            onBlur={() => this.handleDisplayNameBlurr(false)} required
                                            placeholder="Create a username"
                                            className="form-element-small-input ml-15"></input>

                                        <div className="suggest-text mt-1">yourmasterpieces.com/{this.state.formInputs.display_name}</div>

                                    </div>


                                </div>
                            </div>


                            <div className="user-profile-form-section">
                                <div className="profile-details-dropdown-container">

                                    <div className="form-element-user-profile">
                                        <p className="form-section-name-user-profile">NAME</p>
                                        <input value={this.state.formInputs.full_name} type="text" name="full_name"
                                            onChange={this.handleInputChange.bind(this)} required placeholder="Your name"
                                            className="form-element-small-input ml-15"></input>
                                    </div>

                                    <div className="profile-details-country-dropdown col-xs-12">
                                        <p className="form-section-name-user-profile">COUNTRY</p>
                                        <CountryDropdown className="form-element-small-input ml15"
                                            placeholder="Select your country"
                                            value={this.state.formInputs.country}
                                            onChange={(val) => this.selectCountry(val)}
                                        />
                                    </div>
                                </div>


                                <div className="profile-details-dropdown-container">

                                    <div className="profile-details-country-dropdown col-xs-12">
                                        <p className="form-section-name-user-profile">PREFERRED CURRENCY</p>

                                        <select onChange={this.handleCurrencySelection.bind(this)} value={this.state.formInputs.preferred_currency}
                                            placeholder="Preferred currency"
                                            className="form-element-small-input ml15 mr-25" >
                                            <option style={{ display: "none" }} >Preferred currency</option>
                                            {
                                                this.props.generalStore.Currencies.map((el, idx) =>
                                                    <option value={el.key}>{el.display}</option>
                                                )
                                            }
                                        </select>
                                    </div>

                                    <div className="profile-details-country-dropdown col-xs-12">
                                        <p className="form-section-name-user-profile">COMMUNICATION EMAIL <span style={{ display: (this.state.formInputs.email_verified) ? "none" : "", color: "#D0021B", fontSize: "10px" }}>Verification pending</span></p>
                                        <input type="email" name="primary_email" value={this.state.formInputs.primary_email}
                                            onChange={this.handleInputChange.bind(this)}
                                            placeholder="Your email"
                                            className="form-element-small-input" />

                                    </div>

                                </div>


                                <div style={{ display: "flex", flex: 1 }}>


                                    <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-right mt-15 mb-30" style={{ marginBottom: "30px" }}>
                                        <Button onClick={this.handleBackClick.bind(this)} className="masterpieces-secondary-buttons button-prev ml-0 step2-button-secondary f-15">
                                            BACK
                                        </Button>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-right mt-15 mb-30" style={{ marginBottom: "30px" }}>
                                        <Button onClick={this.handleSaveClick.bind(this)} className="masterpieces-primary-buttons step2-button-primary width-100 ml-0 mob-button lastboardingbtn">SAVE
                                        </Button>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/onboarding3-modal.js